import * as React from 'react';
import * as styles from '../Messages.css';
import { IAButton } from '../../button/Button';
import { LocalizationService } from '../../../services/LocalizationService';
import { ITemplate } from '../../../interfaces/templates/ITemplate';
import { IMessageType } from './Header';


export interface IAddMessageDropdownProps {
  addNewMessage: (messageType: IMessageType, jsonTemplate?: string, templateName?: string) => void;
  hideDropdown: () => void;
  containerRef: HTMLDivElement;
  availableTemplates?: ITemplate[];
  disableAddPost?: boolean;
  disableAddNewsLink?: boolean;
  isEvents?: boolean;
}

export class IAAddMessageDropdown extends React.Component<IAddMessageDropdownProps> {

  private readonly localizationService = new LocalizationService();
  
  constructor(props) {
    super(props);
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
  }

  private handleClick(event: Event) {    
    if (this.props.hideDropdown && this.props.containerRef && !this.props.containerRef.contains(event.target as Node)) {
      this.props.hideDropdown();
    }
  }

  componentDidMount() {
    document.addEventListener("mousedown", (e) => this.handleClick(e));
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", (e) => this.handleClick(e));
  }

  private getButton(label: string, onClick: () => void): JSX.Element {
    return <IAButton
      label={label}
      borderColor="white"
      mouseOverButtonColor="#eee"
      fontSize={14}
      onClick={() => onClick()}
      styleLabel={{
        textAlign: "left",
        marginLeft: 10
      }}
      height={"auto"}
      minHeight={40}
    />
  }

  public render(): JSX.Element {
    return (
      <div
        className={styles.IA_addMessageDropdown}
        onClick={(e) => e.stopPropagation()}
      >
        {!this.props.disableAddPost && this.getButton(this.props.isEvents ? this.localizationService.strings.Messages_AddEvent : this.localizationService.strings.Messages_AddMessage, () => this.setState({showAddMessageDropDown: false}, () => this.props.addNewMessage("message")))}
        {!this.props.disableAddNewsLink && this.getButton(this.localizationService.strings.Messages_AddNewsLink, () => this.setState({showAddMessageDropDown: false}, () => this.props.addNewMessage("newsLink")))}
        {this.props.availableTemplates?.length > 0 && this.props.availableTemplates.map(template => {
          return this.getButton(template.title, () => this.setState({showAddMessageDropDown: false}, () => this.props.addNewMessage("template", template.jsonTemplate, template.title)));
        })}
      </div>
    )
  }
}